import { PUBLIC_API_URL_ENV } from 'tools/environments';
import { GetSeasonTicketPathwayResponse, GetSeasonTicketPathwayError } from './types/get-season-ticket-pathway.type';

export const getSeasonTicketPathway = (filters: Record<string, unknown> = {}): Promise<GetSeasonTicketPathwayResponse> => {
	const qs = new URLSearchParams();
	filters.token && qs.append('token', String(filters.token || ''));
	filters.id && qs.append('id', String(filters.id || ''));

	return fetch(`${PUBLIC_API_URL_ENV}/step${filters.token || filters.id ? '?' + qs : ''}`, {
		method: 'GET',
		credentials: 'include',
		cache: 'no-store',
	})
		.then((res) => {
			if (res.ok) return res.json() as Promise<GetSeasonTicketPathwayResponse>;

			const error = new Error(res.statusText) as GetSeasonTicketPathwayError;
			error.status = res.status;
			throw error;
		})
		.catch((error) => {
			console.error('SeasonTicketPathway request error: ', error);
			throw error;
		});
}
